module.exports = __webpack_public_path__ + "static/peppers-van-f0029315610502826b5ca4dc5dfb22ea.jpg";